import React from 'react';
import AdMessage from './components/AdMessage';
import { useStore } from '../../../../../../store/rootStore';
const FacebookMessage = ({ message }) => {
    const { files } = useStore();
    return (React.createElement("div", null, message.referral && React.createElement(AdMessage, { referral: message.referral, shareFile: files.shareFile, embedAd: true })));
};
export default FacebookMessage;
